var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-popup',{attrs:{"show":_vm.showPopup,"title":"新增自定义检查点"},on:{"on-close":function($event){return _vm.$emit('on-close')}}},[_vm._v(" 11111")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }